import { WIDGET_SHADOW_ROOT_ENABLED_DATA_ATTR } from "@/constants";
import { REWARDS_WIDGET_NAMES } from "@/constants/widget-names";
import { RewardsVipTiersMultiProgressWidgetDefinition } from "@apps/rewards/constants/definitions";
import type { RewardsWidgetInjectorConfig } from "@apps/rewards/types";
import WidgetInjectedSdkEvent from "@modules/sdk/common_sdk/events/WidgetInjectedSdkEvent";
import { dispatchSdkEvent } from "@modules/sdk/helpers";
import { parseOptionalBooleanDataAttr } from "@ui-utils/Injector/utils";

class RewardsVipTiersMultiProgressWidgetInjector {
    constructor(private readonly config: RewardsWidgetInjectorConfig) {}

    start(): void {
        this.config.logger.debug(
            "RewardsVipTiersMultiProgressWidgetInjector start",
            {
                placeholderSelector: this.config.placeholderSelector,
            }
        );

        const widgetName =
            REWARDS_WIDGET_NAMES.REWARDS_VIP_TIERS_MULTI_PROGRESS_WIDGET;

        const targets$ = this.config.mutationObserverInjector.register({
            targetSelector: this.config.placeholderSelector,
        });

        targets$.subscribe((placeholder) => {
            this.config.logger?.debug(
                "RewardsVipTiersMultiProgressWidgetInjector found placeholder",
                {
                    placeholder,
                }
            );

            void (async () => {
                const RewardsVipTiersMultiProgressWidget =
                    await this.config.dynamicImportManager.importDefault(
                        RewardsVipTiersMultiProgressWidgetDefinition,
                        true
                    );

                const widget = new RewardsVipTiersMultiProgressWidget(
                    {
                        target: placeholder,
                        isWidgetShadowRootEnabled: parseOptionalBooleanDataAttr(
                            placeholder,
                            WIDGET_SHADOW_ROOT_ENABLED_DATA_ATTR
                        ),
                    },
                    this.config.logger
                );

                await widget.init();

                this.config.eventsCollector.pushEvent(
                    this.config.eventsFactory.createWidgetInjected(widgetName)
                );

                dispatchSdkEvent(new WidgetInjectedSdkEvent(widgetName));
            })();
        });
    }
}

export default RewardsVipTiersMultiProgressWidgetInjector;
